export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
};

export enum AccreditationStatus {
  ACCREDITED = 'ACCREDITED',
  EXTERNAL_ACCREDITED = 'EXTERNAL_ACCREDITED',
  EXTERNAL_NON_ACCREDITED = 'EXTERNAL_NON_ACCREDITED',
  NON_ACCREDITED = 'NON_ACCREDITED'
}

export type Article = {
  __typename?: 'Article';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inventoryID?: Maybe<Scalars['String']['output']>;
};

export type Calculation = {
  __typename?: 'Calculation';
  calculationType: CalculationType;
  connectionPrice: Array<Price>;
  humanPrice: Price;
  id: Scalars['ID']['output'];
  machinePrice: Price;
  offerText: Scalars['String']['output'];
};

export type CalculationInput = {
  calculationType: CalculationType;
  connectionPrice: Array<PriceInput>;
  humanPrice: PriceInput;
  id: Scalars['ID']['input'];
  machinePrice: PriceInput;
  offerText: Scalars['String']['input'];
};

export enum CalculationType {
  CONNECTION = 'Connection',
  TIME = 'Time'
}

export type Chapter = {
  __typename?: 'Chapter';
  chapterNumber: Scalars['String']['output'];
  data: Array<DataNode>;
  examinationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  open: Scalars['Boolean']['output'];
  subChapter?: Maybe<Array<Chapter>>;
  type: ChapterType;
};

export type ChapterInput = {
  chapterNumber: Scalars['String']['input'];
  data: Array<DataNodeInput>;
  examinationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  open: Scalars['Boolean']['input'];
  subChapter?: InputMaybe<Array<ChapterInput>>;
  type: ChapterType;
};

export enum ChapterType {
  APPENDIX = 'APPENDIX',
  APPENDIX_A = 'APPENDIX_A',
  EUT = 'EUT',
  EUT_AUX = 'EUT_AUX',
  EUT_CONNECTIONS = 'EUT_CONNECTIONS',
  EUT_ENTRANCE_EXAMEN = 'EUT_ENTRANCE_EXAMEN',
  EUT_EUT = 'EUT_EUT',
  EUT_FUNCTIONAL_CHECKS = 'EUT_FUNCTIONAL_CHECKS',
  EUT_GENERAL_PASS_FAIL_CRITERIA = 'EUT_GENERAL_PASS_FAIL_CRITERIA',
  INDEX = 'INDEX',
  OVERVIEW = 'OVERVIEW',
  OWN_CHAPTER = 'OWN_CHAPTER',
  TEST = 'TEST',
  TEST_EQUIPMENT = 'TEST_EQUIPMENT',
  TEST_EXTERNAL_WITNESS = 'TEST_EXTERNAL_WITNESS',
  TEST_LOCATION_AND_CONDITIONS = 'TEST_LOCATION_AND_CONDITIONS',
  TEST_RESULTS = 'TEST_RESULTS',
  TEST_SETUP = 'TEST_SETUP',
  TEST_SPECIFICATIONS = 'TEST_SPECIFICATIONS',
  TEST_SPECIFICATIONS_ADAPTED_STANDARD = 'TEST_SPECIFICATIONS_ADAPTED_STANDARD',
  TEST_SPECIFICATIONS_DEVITATIONS = 'TEST_SPECIFICATIONS_DEVITATIONS',
  TEST_SPECIFICATIONS_PARAMETER_AND_CATEGORY = 'TEST_SPECIFICATIONS_PARAMETER_AND_CATEGORY',
  TEST_SPECIFICATIONS_PASS_FAIL_CRITERIA = 'TEST_SPECIFICATIONS_PASS_FAIL_CRITERIA',
  TEST_SPECIFICATIONS_QTP = 'TEST_SPECIFICATIONS_QTP',
  TEST_SPECIFICATIONS_REMARKS = 'TEST_SPECIFICATIONS_REMARKS'
}

export type Company = {
  __typename?: 'Company';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ConnectionBasedNormInput = {
  ac1Phase?: InputMaybe<Scalars['Float']['input']>;
  ac3Phase?: InputMaybe<Scalars['Float']['input']>;
  branch?: InputMaybe<Scalars['String']['input']>;
  configName?: InputMaybe<Scalars['String']['input']>;
  costMachine?: InputMaybe<Scalars['Float']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dc?: InputMaybe<Scalars['Float']['input']>;
  enclosure?: InputMaybe<Scalars['Float']['input']>;
  examinationProcedure?: InputMaybe<Scalars['String']['input']>;
  isAccredited?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<TreoLocationInput>;
  name: Scalars['String']['input'];
  offerText?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  signal?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tk?: InputMaybe<Scalars['Float']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  active?: Maybe<Scalars['Boolean']['output']>;
  businessAccount?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactID?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  languageOrLocale?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone1?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
  phone3?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  DateOfBirth?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Fax?: Maybe<Scalars['String']['output']>;
  FaxType?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  MiddleName?: Maybe<Scalars['String']['output']>;
  Phone1?: Maybe<Scalars['String']['output']>;
  Phone1Type?: Maybe<Scalars['String']['output']>;
  Phone2?: Maybe<Scalars['String']['output']>;
  Phone2Type?: Maybe<Scalars['String']['output']>;
  Phone3?: Maybe<Scalars['String']['output']>;
  Phone3Type?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  WebSite?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  businessAccount?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactID?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  languageOrLocale?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone1?: InputMaybe<Scalars['String']['input']>;
  phone2?: InputMaybe<Scalars['String']['input']>;
  phone3?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactInput = {
  businessAccountID: Scalars['String']['input'];
  contactClass?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phone1?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerInput = {
  currencyID: Scalars['String']['input'];
  customerClass: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  locationName?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  taxZone?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSalesQuoteFromOpportunityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  opportunityID: Scalars['ID']['input'];
};

export type Criteria = {
  __typename?: 'Criteria';
  description: Array<DataNode>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  operatingModes: Array<Scalars['String']['output']>;
};

export type CriteriaCatalog = {
  __typename?: 'CriteriaCatalog';
  chapterNeeded: Scalars['Boolean']['output'];
  criteriaList: Array<Criteria>;
  description: Array<DataNode>;
  examinationConfig: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  norm: Array<Scalars['String']['output']>;
};

export type CriteriaCatalogInput = {
  chapterNeeded: Scalars['Boolean']['input'];
  criteriaList: Array<CriteriaInput>;
  description: Array<DataNodeInput>;
  examinationConfig: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  norm: Array<Scalars['String']['input']>;
};

export type CriteriaInput = {
  description: Array<DataNodeInput>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  operatingModes: Array<Scalars['String']['input']>;
};

export type Customer = {
  __typename?: 'Customer';
  addressLine1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currencyID?: Maybe<Scalars['String']['output']>;
  customerClass?: Maybe<Scalars['String']['output']>;
  customerID?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  phone1?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taxZone?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
};

export type Data = {
  __typename?: 'Data';
  note: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type DataInput = {
  note: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type DataNode = {
  __typename?: 'DataNode';
  dataType: NodeDataType;
  deletable: Scalars['Boolean']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  image: Array<Scalars['String']['output']>;
  imageCaption: Array<Scalars['String']['output']>;
  imageNumber: Array<Scalars['Int']['output']>;
  isAutoGenerated?: Maybe<Scalars['Boolean']['output']>;
  originalTextBlockDataNodeNo?: Maybe<Scalars['Int']['output']>;
  originalTextblockId?: Maybe<Scalars['String']['output']>;
  sourceExaminationId?: Maybe<Scalars['String']['output']>;
  tableBody: Array<Array<TableCell>>;
  tableCaption: Scalars['String']['output'];
  tableHeader: Array<TableCell>;
  tableNumber: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type DataNodeInput = {
  dataType: NodeDataType;
  deletable: Scalars['Boolean']['input'];
  editable: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  image?: InputMaybe<Array<Scalars['String']['input']>>;
  imageCaption?: InputMaybe<Array<Scalars['String']['input']>>;
  imageNumber?: InputMaybe<Array<Scalars['Int']['input']>>;
  isAutoGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  originalTextBlockDataNodeNo?: InputMaybe<Scalars['Int']['input']>;
  originalTextblockId?: InputMaybe<Scalars['String']['input']>;
  sourceExaminationId?: InputMaybe<Scalars['String']['input']>;
  tableBody?: InputMaybe<Array<InputMaybe<Array<TableCellInput>>>>;
  tableCaption?: InputMaybe<Scalars['String']['input']>;
  tableHeader?: InputMaybe<Array<TableCellInput>>;
  tableNumber?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum DataType {
  BOOLEAN = 'BOOLEAN',
  FLOAT = 'FLOAT',
  STRING = 'STRING'
}

export type Device = {
  barcode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  documents: Array<File>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Array<File>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
  type: DeviceType;
};

export type DeviceAux = Device & {
  __typename?: 'DeviceAux';
  barcode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  deviceDataGroup: Array<DeviceDataGroup>;
  documents: Array<File>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Array<File>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  movementData: Array<MovementData>;
  name: Scalars['String']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
  type: DeviceType;
};

export type DeviceAuxInput = {
  barcode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  deviceDataGroup: Array<DeviceDataGroupInput>;
  documents: Array<Scalars['ID']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images: Array<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  movementData: Array<MovementDataInput>;
  name: Scalars['String']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  type: DeviceType;
};

export type DeviceConsumable = Device & {
  __typename?: 'DeviceConsumable';
  amount: Scalars['Float']['output'];
  barcode: Scalars['String']['output'];
  charge: Scalars['String']['output'];
  description: Scalars['String']['output'];
  documents: Array<File>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Array<File>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
  type: DeviceType;
  unit: Scalars['String']['output'];
};

export type DeviceConsumableInput = {
  amount: Scalars['Float']['input'];
  barcode: Scalars['String']['input'];
  charge: Scalars['String']['input'];
  description: Scalars['String']['input'];
  documents: Array<Scalars['ID']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images: Array<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  type: DeviceType;
  unit: Scalars['String']['input'];
};

export type DeviceData = {
  __typename?: 'DeviceData';
  data: Array<Data>;
  dataType: DataType;
  id: Scalars['ID']['output'];
  isArray: Scalars['Boolean']['output'];
  isCalculation: Scalars['Boolean']['output'];
  isOperatingMode: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  unit: Array<Scalars['String']['output']>;
};

export type DeviceDataGroup = {
  __typename?: 'DeviceDataGroup';
  deviceData: Array<DeviceData>;
  id: Scalars['ID']['output'];
  isAux: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type DeviceDataGroupInput = {
  deviceData: Array<DeviceDataInput>;
  id: Scalars['ID']['input'];
  isAux: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type DeviceDataInput = {
  data?: InputMaybe<Array<DataInput>>;
  dataType: DataType;
  id: Scalars['ID']['input'];
  isArray: Scalars['Boolean']['input'];
  isCalculation: Scalars['Boolean']['input'];
  isOperatingMode: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  unit: Array<Scalars['String']['input']>;
};

export type DeviceEut = Device & {
  __typename?: 'DeviceEut';
  barcode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  documents: Array<File>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Array<File>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  movementData: Array<MovementData>;
  name: Scalars['String']['output'];
  note: Array<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  software?: Maybe<Scalars['String']['output']>;
  softwareVersion?: Maybe<Scalars['String']['output']>;
  type: DeviceType;
};

export type DeviceEutGroup = Device & {
  __typename?: 'DeviceEutGroup';
  assumptions: Scalars['String']['output'];
  barcode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  deviceDataGroup: Array<DeviceDataGroup>;
  devices: Array<DeviceEut>;
  documents: Array<File>;
  examinations: Array<Examination>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Array<File>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  movementData: Array<MovementData>;
  name: Scalars['String']['output'];
  norms: Array<Norm>;
  notes: Array<Note>;
  productNumber?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  software?: Maybe<Scalars['String']['output']>;
  softwareVersion?: Maybe<Scalars['String']['output']>;
  type: DeviceType;
};

export type DeviceEutGroupInput = {
  assumptions: Scalars['String']['input'];
  barcode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  deviceDataGroup: Array<DeviceDataGroupInput>;
  devices: Array<Scalars['ID']['input']>;
  documents: Array<Scalars['ID']['input']>;
  examinationAndModes: Array<ExaminationAndModeInput>;
  examinations: Array<Scalars['ID']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images: Array<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  movementData: Array<MovementDataInput>;
  name: Scalars['String']['input'];
  norms: Array<Scalars['ID']['input']>;
  notes: Array<NoteInput>;
  productNumber?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  software?: InputMaybe<Scalars['String']['input']>;
  softwareVersion?: InputMaybe<Scalars['String']['input']>;
  type: DeviceType;
};

export type DeviceEutInput = {
  barcode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  documents: Array<Scalars['ID']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images: Array<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  movementData: Array<MovementDataInput>;
  name: Scalars['String']['input'];
  note: Array<Scalars['String']['input']>;
  productNumber?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  software?: InputMaybe<Scalars['String']['input']>;
  softwareVersion?: InputMaybe<Scalars['String']['input']>;
  type: DeviceType;
};

export type DeviceInput = {
  barcode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  images: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type: DeviceType;
};

export type DeviceSetup = {
  __typename?: 'DeviceSetup';
  device: Device;
  images: Array<File>;
  linkedTo?: Maybe<Array<Maybe<LinkedTo>>>;
  note: Scalars['String']['output'];
};

export type DeviceSetupInput = {
  device: Scalars['ID']['input'];
  images: Array<Scalars['ID']['input']>;
  linkedTo: Array<LinkedToInput>;
  note: Scalars['String']['input'];
};

export type DeviceTestData = {
  __typename?: 'DeviceTestData';
  device: Device;
  images: Array<File>;
  note: Scalars['String']['output'];
  result: Array<Result>;
  timestamp: Scalars['String']['output'];
};

export type DeviceTestDataInput = {
  device: Scalars['ID']['input'];
  images: Array<Scalars['ID']['input']>;
  note: Scalars['String']['input'];
  result: Array<ResultInput>;
  timestamp: Scalars['String']['input'];
};

export type DeviceTestEquipment = Device & {
  __typename?: 'DeviceTestEquipment';
  barcode: Scalars['String']['output'];
  calibrationDate?: Maybe<Scalars['String']['output']>;
  calibrationDue: Scalars['String']['output'];
  description: Scalars['String']['output'];
  documents: Array<File>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Array<File>;
  inventoryNo: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
  teType: Scalars['String']['output'];
  type: DeviceType;
  uncertainty: Scalars['String']['output'];
};

export type DeviceTestEquipmentInput = {
  barcode: Scalars['String']['input'];
  calibrationDate?: InputMaybe<Scalars['String']['input']>;
  calibrationDue: Scalars['String']['input'];
  description: Scalars['String']['input'];
  documents: Array<Scalars['ID']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images: Array<Scalars['ID']['input']>;
  inventoryNo: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  teType: Scalars['String']['input'];
  type: DeviceType;
  uncertainty: Scalars['String']['input'];
};

export enum DeviceType {
  AUX = 'AUX',
  CONSUMABLE = 'CONSUMABLE',
  EQUIPMENT_UNDER_TEST = 'EQUIPMENT_UNDER_TEST',
  EUT_GROUP = 'EUT_GROUP',
  TEST_EQUIPMENT = 'TEST_EQUIPMENT'
}

export enum DocumentClassification {
  CLASSIFIED = 'CLASSIFIED',
  CONFIDENTIAL = 'CONFIDENTIAL',
  NOT_CLASSIFIED = 'NOT_CLASSIFIED',
  SECRET = 'SECRET'
}

export type Employee = {
  __typename?: 'Employee';
  ContactInfo?: Maybe<ContactInfo>;
  EmployeeID?: Maybe<Scalars['String']['output']>;
  EmployeeName?: Maybe<Scalars['String']['output']>;
  LastModifiedDateTime?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  _links?: Maybe<EmployeeLinks>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type EmployeeLinks = {
  __typename?: 'EmployeeLinks';
  files_put?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['String']['output']>;
};

export type ExamCalc = {
  __typename?: 'ExamCalc';
  calculation: Calculation;
  examinationConfig: ExaminationConfig;
  id: Scalars['ID']['output'];
  isAccredited: Scalars['Boolean']['output'];
  location?: Maybe<TreoLocation>;
  name: Scalars['String']['output'];
  tags: Array<Tag>;
};

export type ExamCalcFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ExamCalcInput = {
  calculation: CalculationInput;
  examinationConfig: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  isAccredited: Scalars['Boolean']['input'];
  location?: InputMaybe<TreoLocationInput>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<TagInput>>;
};

export type Examination = {
  __typename?: 'Examination';
  calculation: Calculation;
  changedBy?: Maybe<Scalars['String']['output']>;
  deviations?: Maybe<Scalars['String']['output']>;
  deviceSetup: Array<DeviceSetup>;
  endTimestamp?: Maybe<Scalars['String']['output']>;
  examinationConfig: ExaminationConfig;
  history: Array<History>;
  id: Scalars['ID']['output'];
  isAccredited: Scalars['Boolean']['output'];
  laboratory?: Maybe<Laboratory>;
  location: TreoLocation;
  name: Scalars['String']['output'];
  norm: Norm;
  numberOfRuns?: Maybe<Scalars['Int']['output']>;
  operatingModes: Array<Scalars['String']['output']>;
  passFailCriteria: Array<CriteriaCatalog>;
  salesQuote?: Maybe<Scalars['String']['output']>;
  specialArrangements: Scalars['String']['output'];
  startTimestamp?: Maybe<Scalars['String']['output']>;
  status: Status;
  tasks: Array<Task>;
  testParameterBlock: Array<TextBlock>;
  tester?: Maybe<Employee>;
  timeStamp?: Maybe<Scalars['String']['output']>;
};

export type ExaminationAndModeInput = {
  examination: Scalars['ID']['input'];
  operatingModes: Array<Scalars['String']['input']>;
};

export type ExaminationConfig = {
  __typename?: 'ExaminationConfig';
  article: Scalars['ID']['output'];
  defaultCalculation: Calculation;
  eutDataGroups: Array<DeviceDataGroup>;
  id: Scalars['ID']['output'];
  isObsolete: Scalars['Boolean']['output'];
  laboratory?: Maybe<Laboratory>;
  location?: Maybe<TreoLocation>;
  name: Scalars['String']['output'];
  skill?: Maybe<Skill>;
  tasks: Array<TaskConfig>;
};

export type ExaminationConfigInput = {
  article: Scalars['ID']['input'];
  defaultCalculation: CalculationInput;
  eutDataGroups: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  laboratory: Scalars['ID']['input'];
  location?: InputMaybe<TreoLocationInput>;
  name: Scalars['String']['input'];
  skill?: InputMaybe<Scalars['ID']['input']>;
  tasks: Array<Scalars['ID']['input']>;
};

export type ExaminationInput = {
  calculation: CalculationInput;
  changedBy?: InputMaybe<Scalars['String']['input']>;
  deviations?: InputMaybe<Scalars['String']['input']>;
  deviceSetup: Array<DeviceSetupInput>;
  endTimestamp?: InputMaybe<Scalars['String']['input']>;
  examinationConfig: Scalars['ID']['input'];
  history: Array<HistoryInput>;
  id: Scalars['ID']['input'];
  isAccredited: Scalars['Boolean']['input'];
  laboratory: Scalars['ID']['input'];
  location: TreoLocationInput;
  name: Scalars['String']['input'];
  norm: Scalars['ID']['input'];
  numberOfRuns?: InputMaybe<Scalars['Int']['input']>;
  passFailCriteria: Array<CriteriaCatalogInput>;
  salesQuote?: InputMaybe<Scalars['String']['input']>;
  specialArrangements: Scalars['String']['input'];
  startTimestamp?: InputMaybe<Scalars['String']['input']>;
  status: Status;
  tasks?: InputMaybe<Array<TaskInput>>;
  testParameterBlock: Array<TextBlockInput>;
  tester?: InputMaybe<Scalars['ID']['input']>;
};

export type FieldChange = {
  __typename?: 'FieldChange';
  changeType: Scalars['String']['output'];
  fieldPath: Scalars['String']['output'];
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
};

export type File = {
  __typename?: 'File';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fileURL: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: FileType;
};

export type FileInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileURL: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum FileType {
  IMAGE = 'IMAGE',
  OTHER = 'OTHER',
  PDF = 'PDF'
}

export type FileUploadInput = {
  base64: Scalars['String']['input'];
  createdAt: Scalars['String']['input'];
  createdBy: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: FileType;
};

export type History = {
  __typename?: 'History';
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  description: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type HistoryEntry = {
  __typename?: 'HistoryEntry';
  changeDetails?: Maybe<Array<FieldChange>>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  description: Array<Scalars['String']['output']>;
  entryType: Scalars['String']['output'];
  examinationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type HistoryInput = {
  createdAt: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type HistoryResult = {
  __typename?: 'HistoryResult';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  items: Array<HistoryEntry>;
  totalCount: Scalars['Int']['output'];
};

export enum IssueStatus {
  APPROVED = 'APPROVED',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  FINAL = 'FINAL',
  REVIEW = 'REVIEW'
}

export type Laboratory = {
  __typename?: 'Laboratory';
  id: Scalars['ID']['output'];
  manager: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LaboratoryInput = {
  id: Scalars['ID']['input'];
  manager: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type Lead = {
  __typename?: 'Lead';
  amount?: Maybe<Scalars['Float']['output']>;
  businessAccount?: Maybe<Scalars['String']['output']>;
  currencyID?: Maybe<Scalars['String']['output']>;
  estimatedCloseDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  opportunityID?: Maybe<Scalars['String']['output']>;
  ownerEmployeeName?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type LinkedTo = {
  __typename?: 'LinkedTo';
  device: Device;
  note: Scalars['String']['output'];
};

export type LinkedToInput = {
  device: Scalars['ID']['input'];
  deviceType: DeviceType;
  note: Scalars['String']['input'];
};

export type MovementData = {
  __typename?: 'MovementData';
  carrier: Scalars['String']['output'];
  date: Scalars['String']['output'];
  eutIsOk: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  note: Scalars['String']['output'];
  packageIsOk: Scalars['Boolean']['output'];
  shipmentNumber: Scalars['String']['output'];
  type: MovementType;
};

export type MovementDataInput = {
  carrier: Scalars['String']['input'];
  date: Scalars['String']['input'];
  eutIsOk: Scalars['Boolean']['input'];
  location: Scalars['String']['input'];
  note: Scalars['String']['input'];
  packageIsOk: Scalars['Boolean']['input'];
  shipmentNumber: Scalars['String']['input'];
  type: MovementType;
};

export enum MovementType {
  ENTRANCE = 'ENTRANCE',
  EXIT = 'EXIT',
  IN_HOUSE = 'IN_HOUSE'
}

export type Mutation = {
  __typename?: 'Mutation';
  copyReport: Scalars['String']['output'];
  createContact?: Maybe<Contact>;
  createCustomer?: Maybe<Customer>;
  createReportVersion: Scalars['String']['output'];
  createSalesQuoteFromOpportunity: Scalars['Boolean']['output'];
  deleteCriteriaCatalog: Scalars['Boolean']['output'];
  deleteDevice: Scalars['Boolean']['output'];
  deleteDeviceDataGroup: Scalars['Boolean']['output'];
  deleteExamination: Scalars['Boolean']['output'];
  deleteExaminationConfig: Scalars['Boolean']['output'];
  deleteFile: Scalars['Boolean']['output'];
  deleteLaboratory: Scalars['Boolean']['output'];
  deleteNorm: Scalars['Boolean']['output'];
  deleteProjects: Scalars['Boolean']['output'];
  deleteSkill: Scalars['Boolean']['output'];
  deleteTaskConfig: Scalars['Boolean']['output'];
  deleteTextBlock: Scalars['Boolean']['output'];
  deleteUnusedExaminations: Scalars['Boolean']['output'];
  getReportVersions: Array<ReportVersion>;
  importNormenFromExcel: Scalars['Boolean']['output'];
  refreshPrimasEquipment: Scalars['String']['output'];
  restoreReportVersion: Scalars['String']['output'];
  setExaminationConfigsObsolete: Scalars['Boolean']['output'];
  setNormsDeleted: Scalars['Boolean']['output'];
  updateContact?: Maybe<Contact>;
  updateCustomer?: Maybe<Customer>;
  updateSalesQuote?: Maybe<SalesQuote>;
  updateTaskWorkingTime: Scalars['Boolean']['output'];
  uploadFile: Scalars['String']['output'];
  upsertCriteriaCatalog: Scalars['String']['output'];
  upsertDeviceAux: Scalars['String']['output'];
  upsertDeviceConsumable: Scalars['String']['output'];
  upsertDeviceDataGroup: DeviceDataGroup;
  upsertDeviceEut: Scalars['String']['output'];
  upsertDeviceEutGroup: Scalars['String']['output'];
  upsertDeviceTestEquipment: Scalars['String']['output'];
  upsertExamination: Scalars['String']['output'];
  upsertExaminationConfig: Scalars['String']['output'];
  upsertLaboratory: Scalars['String']['output'];
  upsertNorm: Scalars['String']['output'];
  upsertProject: Scalars['String']['output'];
  upsertReport: ReportMutationResponse;
  upsertSkill: Scalars['String']['output'];
  upsertTaskConfig: TaskConfig;
  upsertTextBlock: Scalars['String']['output'];
};


export type MutationCopyReportArgs = {
  id: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateReportVersionArgs = {
  reportId: Scalars['ID']['input'];
  versionComment?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSalesQuoteFromOpportunityArgs = {
  input: CreateSalesQuoteFromOpportunityInput;
};


export type MutationDeleteCriteriaCatalogArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDeviceArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDeviceDataGroupArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteExaminationArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteExaminationConfigArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteFileArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteLaboratoryArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteNormArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProjectsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteSkillArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTaskConfigArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTextBlockArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationGetReportVersionsArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationImportNormenFromExcelArgs = {
  input: NormenImportInput;
};


export type MutationRefreshPrimasEquipmentArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRestoreReportVersionArgs = {
  reportId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};


export type MutationSetExaminationConfigsObsoleteArgs = {
  ids: Array<Scalars['ID']['input']>;
  obsolete: Scalars['Boolean']['input'];
  obsoleteAt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetNormsDeletedArgs = {
  deleted: Scalars['Boolean']['input'];
  deletedAt?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateSalesQuoteArgs = {
  input: UpdateSalesQuoteInput;
};


export type MutationUpdateTaskWorkingTimeArgs = {
  examinationId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  workingTime: Scalars['Int']['input'];
};


export type MutationUploadFileArgs = {
  input: FileUploadInput;
};


export type MutationUpsertCriteriaCatalogArgs = {
  input: CriteriaCatalogInput;
};


export type MutationUpsertDeviceAuxArgs = {
  input: DeviceAuxInput;
};


export type MutationUpsertDeviceConsumableArgs = {
  input: DeviceConsumableInput;
};


export type MutationUpsertDeviceDataGroupArgs = {
  input: DeviceDataGroupInput;
};


export type MutationUpsertDeviceEutArgs = {
  input: DeviceEutInput;
};


export type MutationUpsertDeviceEutGroupArgs = {
  input: DeviceEutGroupInput;
  inputEut: Array<DeviceEutInput>;
  isOffer: Scalars['Boolean']['input'];
};


export type MutationUpsertDeviceTestEquipmentArgs = {
  input: DeviceTestEquipmentInput;
};


export type MutationUpsertExaminationArgs = {
  input: ExaminationInput;
};


export type MutationUpsertExaminationConfigArgs = {
  input: ExaminationConfigInput;
};


export type MutationUpsertLaboratoryArgs = {
  input: LaboratoryInput;
};


export type MutationUpsertNormArgs = {
  input: NormInput;
};


export type MutationUpsertProjectArgs = {
  input: ProjectInput;
};


export type MutationUpsertReportArgs = {
  input: ReportInput;
};


export type MutationUpsertSkillArgs = {
  input: SkillInput;
};


export type MutationUpsertTaskConfigArgs = {
  input: TaskConfigInput;
};


export type MutationUpsertTextBlockArgs = {
  input: TextBlockInput;
};

export enum NodeDataType {
  IMAGE = 'IMAGE',
  TABLE = 'TABLE',
  TEXT = 'TEXT'
}

export type Norm = {
  __typename?: 'Norm';
  branch: Scalars['String']['output'];
  date: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  documents: Array<File>;
  examinationCalculations: Array<ExamCalc>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isHarmonized: Scalars['Boolean']['output'];
  isOutdated: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  revision: Scalars['String']['output'];
  tagCloud: Array<TagFrequency>;
};


export type NormExaminationCalculationsArgs = {
  filter?: InputMaybe<ExamCalcFilter>;
};


export type NormTagCloudArgs = {
  filter?: InputMaybe<ExamCalcFilter>;
};

export type NormInput = {
  branch: Scalars['String']['input'];
  date: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['String']['input']>;
  documents: Array<Scalars['String']['input']>;
  examinationCalculations: Array<ExamCalcInput>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isHarmonized: Scalars['Boolean']['input'];
  isOutdated: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  revision: Scalars['String']['input'];
};

export type NormenImportInput = {
  allowPartialImport?: InputMaybe<Scalars['Boolean']['input']>;
  connectionBased?: InputMaybe<Array<ConnectionBasedNormInput>>;
  timeBased?: InputMaybe<Array<TimeBasedNormInput>>;
};

export type Note = {
  __typename?: 'Note';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
};

export type NoteInput = {
  createdAt: Scalars['String']['input'];
  createdBy: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

export type Person = {
  __typename?: 'Person';
  avatarURL: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  cost: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type PriceInput = {
  amount: Scalars['Float']['input'];
  cost: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type PrimasEquipment = {
  __typename?: 'PrimasEquipment';
  equipmentNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inventoryNumber?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type Project = {
  __typename?: 'Project';
  contacts: Array<ProjectContact>;
  description: Scalars['String']['output'];
  desiredDate: Scalars['String']['output'];
  devices: Array<Device>;
  documents: Array<File>;
  id: Scalars['ID']['output'];
  lead: Lead;
  management: User;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  plannedDate: Scalars['String']['output'];
  qtp: Array<Scalars['String']['output']>;
  sales: User;
  specialArrangements: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type ProjectContact = {
  __typename?: 'ProjectContact';
  contactID: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectContactInput = {
  contactID: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ProjectInput = {
  contacts: Array<ProjectContactInput>;
  description: Scalars['String']['input'];
  desiredDate: Scalars['String']['input'];
  devices: Array<Scalars['ID']['input']>;
  documents: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lead: Scalars['String']['input'];
  management: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  plannedDate: Scalars['String']['input'];
  qtp: Array<Scalars['String']['input']>;
  sales: Scalars['String']['input'];
  specialArrangements: Scalars['String']['input'];
  updatedDate: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  contact?: Maybe<Contact>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  examinationHistory: HistoryResult;
  getAllReportsBasicData: Array<Report>;
  getAllWitnesses: Array<Contact>;
  getArticles: Array<Article>;
  getContactById?: Maybe<Contact>;
  getContacts: Array<Contact>;
  getCriteriaCatalogs: Array<CriteriaCatalog>;
  getCurrentWitnesses: Array<Contact>;
  getCustomerById?: Maybe<Customer>;
  getCustomers: Array<Customer>;
  getDevice: Device;
  getDeviceDataGroups: Array<DeviceDataGroup>;
  getDevices: Array<Device>;
  getDevicesByType: Array<Device>;
  getEmployees?: Maybe<Array<Maybe<Employee>>>;
  getExaminationConfigs: Array<ExaminationConfig>;
  getLaboratories: Array<Laboratory>;
  getLeads: Array<Lead>;
  getLeadsArchive: Array<Lead>;
  getNorms: Array<Norm>;
  getPrimasEquipments: Array<PrimasEquipment>;
  getProjects?: Maybe<Array<Maybe<Project>>>;
  getReportById?: Maybe<Report>;
  getReportVersion?: Maybe<Report>;
  getReportVersions: Array<ReportVersion>;
  getSalesQuoteByQuoteNbr?: Maybe<SalesQuote>;
  getSalesQuoteByQuoteNbrWithDetails?: Maybe<SalesQuoteWithDetails>;
  getSalesQuoteDetailsByQuoteID: Array<SalesQuoteDetail>;
  getSalesQuotes: Array<SalesQuote>;
  getSalesQuotesByOpportunityID: Array<SalesQuote>;
  getSalesQuotesByOpportunityIDs: Array<Array<SalesQuote>>;
  getSkills: Array<Skill>;
  getTaskConfigs: Array<TaskConfig>;
  getTextBlocks: Array<TextBlock>;
  getUsers: Array<User>;
  searchWitnesses: Array<Contact>;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  businessAccountID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExaminationHistoryArgs = {
  entryType?: InputMaybe<Scalars['String']['input']>;
  examinationId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllWitnessesArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetArticlesArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetContactByIdArgs = {
  contactID: Scalars['String']['input'];
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetContactsArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCustomerByIdArgs = {
  customerID: Scalars['String']['input'];
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCustomersArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDevicesByTypeArgs = {
  type: DeviceType;
};


export type QueryGetEmployeesArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetLeadsArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetLeadsArchiveArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetNormsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetReportByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetReportVersionArgs = {
  reportId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};


export type QueryGetReportVersionsArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryGetSalesQuoteByQuoteNbrArgs = {
  quoteNbr: Scalars['String']['input'];
};


export type QueryGetSalesQuoteByQuoteNbrWithDetailsArgs = {
  quoteNbr: Scalars['String']['input'];
};


export type QueryGetSalesQuoteDetailsByQuoteIdArgs = {
  quoteID: Scalars['ID']['input'];
};


export type QueryGetSalesQuotesArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetSalesQuotesByOpportunityIdArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityID: Scalars['ID']['input'];
};


export type QueryGetSalesQuotesByOpportunityIDsArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityIDs: Array<Scalars['String']['input']>;
};


export type QuerySearchWitnessesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};

export type Reminder = {
  __typename?: 'Reminder';
  creator: User;
  location: Scalars['String']['output'];
  note: Scalars['String']['output'];
  person: Array<User>;
  time: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Report = {
  __typename?: 'Report';
  accreditationStatus: AccreditationStatus;
  assignmentNo?: Maybe<Scalars['String']['output']>;
  chapter: Array<Chapter>;
  classification: DocumentClassification;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  documentNo: Scalars['String']['output'];
  examinations: Array<Examination>;
  formNumber?: Maybe<Scalars['String']['output']>;
  formRevision?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info: Scalars['String']['output'];
  isLatestVersion: Scalars['Boolean']['output'];
  issueStatus: IssueStatus;
  name: Scalars['String']['output'];
  parentVersionId?: Maybe<Scalars['ID']['output']>;
  previousVersions: Array<ReportVersion>;
  projectID: Scalars['String']['output'];
  qualificationTestPlan?: Maybe<Array<Scalars['String']['output']>>;
  releaseDate?: Maybe<Scalars['String']['output']>;
  reportURL: Scalars['String']['output'];
  reviewedBy?: Maybe<Person>;
  reviewerTitle?: Maybe<Scalars['String']['output']>;
  revisions: Array<ReportRevision>;
  showDraftWatermark: Scalars['Boolean']['output'];
  status: ReportStatus;
  testFacility?: Maybe<Scalars['String']['output']>;
  testLocation?: Maybe<Scalars['String']['output']>;
  tester: Array<Person>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  version: Scalars['String']['output'];
  versionComment?: Maybe<Scalars['String']['output']>;
  versionNumber: Scalars['Int']['output'];
};

export type ReportInput = {
  accreditationStatus?: InputMaybe<AccreditationStatus>;
  assignmentNo?: InputMaybe<Scalars['String']['input']>;
  chapter: Array<ChapterInput>;
  classification?: InputMaybe<DocumentClassification>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  documentNo: Scalars['String']['input'];
  examinations: Array<Scalars['ID']['input']>;
  formNumber?: InputMaybe<Scalars['String']['input']>;
  formRevision?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  info: Scalars['String']['input'];
  issueStatus?: InputMaybe<IssueStatus>;
  name: Scalars['String']['input'];
  parentVersionId?: InputMaybe<Scalars['ID']['input']>;
  projectID: Scalars['String']['input'];
  qualificationTestPlan?: InputMaybe<Array<Scalars['String']['input']>>;
  releaseDate?: InputMaybe<Scalars['String']['input']>;
  reportURL: Scalars['String']['input'];
  reviewedById?: InputMaybe<Scalars['ID']['input']>;
  reviewerTitle?: InputMaybe<Scalars['String']['input']>;
  revisions?: InputMaybe<Array<ReportRevisionInput>>;
  showDraftWatermark?: InputMaybe<Scalars['Boolean']['input']>;
  status: ReportStatus;
  testFacility?: InputMaybe<Scalars['String']['input']>;
  testLocation?: InputMaybe<Scalars['String']['input']>;
  tester: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  version: Scalars['String']['input'];
  versionComment?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportMutationResponse = {
  __typename?: 'ReportMutationResponse';
  filteredExaminations: Array<Scalars['String']['output']>;
  reportId: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type ReportRevision = {
  __typename?: 'ReportRevision';
  affectedSections: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issuedBy?: Maybe<Person>;
  reasonsForRevision: Scalars['String']['output'];
  revisionNumber: Scalars['String']['output'];
};

export type ReportRevisionInput = {
  affectedSections: Scalars['String']['input'];
  date: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  issuedById?: InputMaybe<Scalars['ID']['input']>;
  reasonsForRevision: Scalars['String']['input'];
  revisionNumber: Scalars['String']['input'];
};

export enum ReportStatus {
  DONE = 'DONE',
  DRAFT = 'DRAFT'
}

export type ReportVersion = {
  __typename?: 'ReportVersion';
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  reportId: Scalars['ID']['output'];
  status: ReportStatus;
  version: Scalars['String']['output'];
  versionComment?: Maybe<Scalars['String']['output']>;
  versionNumber: Scalars['Int']['output'];
};

export type Result = {
  __typename?: 'Result';
  criteria: Scalars['String']['output'];
  criteriaCatalog: Scalars['String']['output'];
  operatingMode: Scalars['String']['output'];
  type: ResultType;
};

export type ResultInput = {
  criteria: Scalars['String']['input'];
  criteriaCatalog: Scalars['String']['input'];
  operatingMode: Scalars['String']['input'];
  type: ResultType;
};

export enum ResultType {
  FAILED = 'FAILED',
  NOT_EVALUATED = 'NOT_EVALUATED',
  PASSED = 'PASSED'
}

export type SalesQuote = {
  __typename?: 'SalesQuote';
  businessAccount?: Maybe<Scalars['String']['output']>;
  contactContact?: Maybe<Scalars['String']['output']>;
  contactID?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  opportunityID?: Maybe<Scalars['String']['output']>;
  ownerContact?: Maybe<Scalars['String']['output']>;
  ownerID?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  quoteNbr?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  textFooter?: Maybe<Scalars['String']['output']>;
  textHeader?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type SalesQuoteDetail = {
  __typename?: 'SalesQuoteDetail';
  LIMSguid?: Maybe<Scalars['String']['output']>;
  akkreditiert?: Maybe<Scalars['Boolean']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  extPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  lineNbr?: Maybe<Scalars['String']['output']>;
  norm?: Maybe<Scalars['String']['output']>;
  productID?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quoteID: Scalars['String']['output'];
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type SalesQuoteDetailInput = {
  LIMSguid?: InputMaybe<Scalars['String']['input']>;
  akkreditiert?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inventoryID?: InputMaybe<Scalars['String']['input']>;
  inventoryItemBody?: InputMaybe<Scalars['String']['input']>;
  norm?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quoteID?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  uom?: InputMaybe<Scalars['String']['input']>;
  warehouse?: InputMaybe<Scalars['String']['input']>;
};

export type SalesQuoteWithDetails = {
  __typename?: 'SalesQuoteWithDetails';
  details: Array<SalesQuoteDetail>;
  salesQuote: SalesQuote;
};

export type Skill = {
  __typename?: 'Skill';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  person: Array<Scalars['ID']['output']>;
  testEquipment: Array<DeviceTestEquipment>;
};

export type SkillInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  person: Array<Scalars['ID']['input']>;
  testEquipment: Array<Scalars['ID']['input']>;
};

export enum Status {
  BILLED = 'BILLED',
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
  OPEN = 'OPEN',
  PAUSED = 'PAUSED'
}

export type TableCell = {
  __typename?: 'TableCell';
  colSpan: Scalars['Int']['output'];
  data: Scalars['String']['output'];
};

export type TableCellInput = {
  colSpan: Scalars['Int']['input'];
  data: Scalars['String']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TagFrequency = {
  __typename?: 'TagFrequency';
  count: Scalars['Int']['output'];
  tag: Tag;
};

export type TagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type Task = {
  __typename?: 'Task';
  estimatedTime: Scalars['Int']['output'];
  examinator?: Maybe<User>;
  id: Scalars['ID']['output'];
  info: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Status;
  taskSteps: Array<TaskStep>;
  testDatas: Array<TestData>;
  workingTime: Scalars['Int']['output'];
};

export type TaskConfig = {
  __typename?: 'TaskConfig';
  id: Scalars['ID']['output'];
  info: Scalars['String']['output'];
  name: Scalars['String']['output'];
  taskSteps: Array<TaskStep>;
};

export type TaskConfigInput = {
  id: Scalars['ID']['input'];
  info: Scalars['String']['input'];
  name: Scalars['String']['input'];
  taskSteps: Array<TaskStep>;
};

export type TaskInput = {
  estimatedTime: Scalars['Int']['input'];
  examinator?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  info: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status: Status;
  taskSteps: Array<TaskStep>;
  testDatas?: InputMaybe<Array<TestDataInput>>;
  workingTime: Scalars['Int']['input'];
};

export enum TaskStep {
  ADD_DEVICE = 'ADD_DEVICE',
  ENGINEERING = 'ENGINEERING',
  FUNCTION_TEST = 'FUNCTION_TEST',
  HELPER = 'HELPER',
  NOTE = 'NOTE',
  SAVING = 'SAVING',
  TEST_CONFIGURATION = 'TEST_CONFIGURATION',
  TEST_FOLLOW_UP = 'TEST_FOLLOW_UP',
  WAITING_TIME = 'WAITING_TIME'
}

export type TestData = {
  __typename?: 'TestData';
  ambientConditions?: Maybe<Scalars['Boolean']['output']>;
  beginTime: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  description: Scalars['String']['output'];
  deviceTestData: Array<DeviceTestData>;
  endTime: Scalars['String']['output'];
  helper: Array<User>;
  id: Scalars['ID']['output'];
  image: Array<File>;
  name: Scalars['String']['output'];
  type: TaskStep;
  visualCheck: Scalars['Boolean']['output'];
  witnesses: Array<Maybe<Contact>>;
};

export type TestDataInput = {
  ambientConditions?: InputMaybe<Scalars['Boolean']['input']>;
  beginTime: Scalars['String']['input'];
  createdAt: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  deviceTestData?: InputMaybe<Array<DeviceTestDataInput>>;
  endTime: Scalars['String']['input'];
  helper: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  image: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type: TaskStep;
  visualCheck: Scalars['Boolean']['input'];
  witnesses: Array<InputMaybe<ContactInput>>;
};

export type TextBlock = {
  __typename?: 'TextBlock';
  block: Array<DataNode>;
  chapter: ChapterType;
  examinations: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isTestRelevant: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  norms: Array<Scalars['ID']['output']>;
};

export type TextBlockInput = {
  block: Array<DataNodeInput>;
  chapter: ChapterType;
  examinations: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isTestRelevant: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  norms: Array<Scalars['ID']['input']>;
};

export type TimeBasedNormInput = {
  branch?: InputMaybe<Scalars['String']['input']>;
  configName?: InputMaybe<Scalars['String']['input']>;
  costHuman?: InputMaybe<Scalars['Float']['input']>;
  costMachine?: InputMaybe<Scalars['Float']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  examinationProcedure?: InputMaybe<Scalars['String']['input']>;
  humanTimeHours?: InputMaybe<Scalars['Float']['input']>;
  isAccredited?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<TreoLocationInput>;
  machineTimeHours?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  offerText?: InputMaybe<Scalars['String']['input']>;
  rateHuman?: InputMaybe<Scalars['Float']['input']>;
  rateMachine?: InputMaybe<Scalars['Float']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TreoLocation = {
  __typename?: 'TreoLocation';
  abbreviation: Scalars['String']['output'];
  costCenter: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TreoLocationInput = {
  abbreviation: Scalars['String']['input'];
  costCenter: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateContactInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contactID: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone1?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerInput = {
  currencyID?: InputMaybe<Scalars['String']['input']>;
  customerClass?: InputMaybe<Scalars['String']['input']>;
  customerID: Scalars['String']['input'];
  customerName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  taxZone?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  writeOffLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSalesQuoteInput = {
  businessAccount?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Array<SalesQuoteDetailInput>>;
  id: Scalars['ID']['input'];
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  quoteNbr?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  textFooter?: InputMaybe<Scalars['String']['input']>;
  textHeader?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  userPrincipalName?: Maybe<Scalars['String']['output']>;
};

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'Contact', id: string, contactID?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, email?: string | null, companyName?: string | null, title?: string | null, gender?: string | null, phone1?: string | null, phone2?: string | null, phone3?: string | null, active?: boolean | null, businessAccount?: string | null } | null };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'Contact', id: string, contactID?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, displayName?: string | null, email?: string | null, companyName?: string | null, gender?: string | null, phone1?: string | null, phone2?: string | null, phone3?: string | null, active?: boolean | null, businessAccount?: string | null } | null };

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'Customer', id: string, customerID?: string | null, customerName?: string | null, legalName?: string | null, status?: string | null, email?: string | null, phone1?: string | null, country?: string | null, city?: string | null, postalCode?: string | null, addressLine1?: string | null, currencyID?: string | null, terms?: string | null, customerClass?: string | null, taxZone?: string | null, locationName?: string | null } | null };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'Customer', id: string, customerID?: string | null, customerName?: string | null, legalName?: string | null, status?: string | null, email?: string | null, phone1?: string | null, country?: string | null, city?: string | null, postalCode?: string | null, addressLine1?: string | null, currencyID?: string | null, terms?: string | null, customerClass?: string | null, taxZone?: string | null, locationName?: string | null } | null };

export type CreateSalesQuoteMutationVariables = Exact<{
  input: CreateSalesQuoteFromOpportunityInput;
}>;


export type CreateSalesQuoteMutation = { __typename?: 'Mutation', createSalesQuoteFromOpportunity: boolean };

export type UpdateSalesQuoteMutationVariables = Exact<{
  input: UpdateSalesQuoteInput;
}>;


export type UpdateSalesQuoteMutation = { __typename?: 'Mutation', updateSalesQuote?: { __typename?: 'SalesQuote', id: string, quoteNbr?: string | null, businessAccount?: string | null, contactContact?: string | null, date?: string | null, description?: string | null, total?: number | null, status?: string | null, opportunityID?: string | null, expirationDate?: string | null, note?: string | null, contactID?: string | null, currency?: string | null, location?: string | null, ownerID?: string | null, ownerContact?: string | null, textHeader?: string | null, textFooter?: string | null } | null };

export type GetArticlesQueryVariables = Exact<{
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetArticlesQuery = { __typename?: 'Query', getArticles: Array<{ __typename?: 'Article', id: string, inventoryID?: string | null, description?: string | null }> };

export type GetContactsQueryVariables = Exact<{
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContactsQuery = { __typename?: 'Query', getContacts: Array<{ __typename?: 'Contact', id: string, contactID?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, email?: string | null, companyName?: string | null, title?: string | null, jobTitle?: string | null, gender?: string | null, phone1?: string | null, phone2?: string | null, phone3?: string | null, active?: boolean | null, businessAccount?: string | null }> };

export type GetContactByIdQueryVariables = Exact<{
  contactID: Scalars['String']['input'];
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContactByIdQuery = { __typename?: 'Query', getContactById?: { __typename?: 'Contact', id: string, contactID?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, displayName?: string | null, email?: string | null, companyName?: string | null, gender?: string | null, phone1?: string | null, phone2?: string | null, phone3?: string | null, active?: boolean | null, businessAccount?: string | null } | null };

export type GetCustomersQueryVariables = Exact<{
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCustomersQuery = { __typename?: 'Query', getCustomers: Array<{ __typename?: 'Customer', id: string, customerID?: string | null, customerName?: string | null, legalName?: string | null, status?: string | null, email?: string | null, phone1?: string | null, country?: string | null, city?: string | null, postalCode?: string | null, addressLine1?: string | null, currencyID?: string | null, terms?: string | null, customerClass?: string | null, taxZone?: string | null, locationName?: string | null }> };

export type GetCustomerByIdQueryVariables = Exact<{
  customerID: Scalars['String']['input'];
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCustomerByIdQuery = { __typename?: 'Query', getCustomerById?: { __typename?: 'Customer', id: string, customerID?: string | null, customerName?: string | null, legalName?: string | null, status?: string | null, email?: string | null, phone1?: string | null, country?: string | null, city?: string | null, postalCode?: string | null, addressLine1?: string | null, currencyID?: string | null, terms?: string | null, customerClass?: string | null, taxZone?: string | null, locationName?: string | null } | null };

export type GetEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeesQuery = { __typename?: 'Query', getEmployees?: Array<{ __typename?: 'Employee', id: string, note?: string | null, EmployeeID?: string | null, EmployeeName?: string | null, LastModifiedDateTime?: string | null, Status?: string | null, ContactInfo?: { __typename?: 'ContactInfo', id?: string | null, note?: string | null, DateOfBirth?: string | null, Email?: string | null, Fax?: string | null, FaxType?: string | null, FirstName?: string | null, LastName?: string | null, MiddleName?: string | null, Phone1?: string | null, Phone1Type?: string | null, Phone2?: string | null, Phone2Type?: string | null, Phone3?: string | null, Phone3Type?: string | null, Title?: string | null, WebSite?: string | null } | null, _links?: { __typename?: 'EmployeeLinks', self?: string | null, files_put?: string | null } | null } | null> | null };

export type GetLeadsQueryVariables = Exact<{
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLeadsQuery = { __typename?: 'Query', getLeads: Array<{ __typename?: 'Lead', id: string, opportunityID?: string | null, businessAccount?: string | null, status?: string | null, stage?: string | null, subject?: string | null, amount?: number | null, estimatedCloseDate?: string | null, currencyID?: string | null, reason?: string | null, ownerEmployeeName?: string | null }> };

export type GetLeadsArchiveQueryVariables = Exact<{
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLeadsArchiveQuery = { __typename?: 'Query', getLeadsArchive: Array<{ __typename?: 'Lead', id: string, opportunityID?: string | null, businessAccount?: string | null, status?: string | null, stage?: string | null, subject?: string | null, amount?: number | null, estimatedCloseDate?: string | null, currencyID?: string | null, reason?: string | null, ownerEmployeeName?: string | null }> };

export type GetPrimasEquipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrimasEquipmentsQuery = { __typename?: 'Query', getPrimasEquipments: Array<{ __typename?: 'PrimasEquipment', id: string, equipmentNumber: string, name: string, manufacturer?: string | null, model?: string | null, serialNumber?: string | null, inventoryNumber?: string | null }> };

export type GetSalesQuotesQueryVariables = Exact<{
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSalesQuotesQuery = { __typename?: 'Query', getSalesQuotes: Array<{ __typename?: 'SalesQuote', id: string, quoteNbr?: string | null, businessAccount?: string | null, contactContact?: string | null, date?: string | null, description?: string | null, total?: number | null, status?: string | null, opportunityID?: string | null, expirationDate?: string | null, note?: string | null, contactID?: string | null, currency?: string | null, location?: string | null, ownerID?: string | null, ownerContact?: string | null, textHeader?: string | null, textFooter?: string | null }> };

export type GetSalesQuoteDetailsQueryVariables = Exact<{
  quoteID: Scalars['ID']['input'];
}>;


export type GetSalesQuoteDetailsQuery = { __typename?: 'Query', getSalesQuoteDetailsByQuoteID: Array<{ __typename?: 'SalesQuoteDetail', id: string, quoteID: string, lineNbr?: string | null, productID?: string | null, description?: string | null, quantity?: number | null, unitPrice?: number | null, extPrice?: number | null, discountPercent?: number | null, discountAmount?: number | null }> };

export type GetSalesQuoteByQuoteNbrWithDetailsQueryVariables = Exact<{
  quoteNbr: Scalars['String']['input'];
}>;


export type GetSalesQuoteByQuoteNbrWithDetailsQuery = { __typename?: 'Query', getSalesQuoteByQuoteNbrWithDetails?: { __typename?: 'SalesQuoteWithDetails', salesQuote: { __typename?: 'SalesQuote', id: string, quoteNbr?: string | null, businessAccount?: string | null, contactContact?: string | null, date?: string | null, description?: string | null, total?: number | null, status?: string | null, opportunityID?: string | null, expirationDate?: string | null, note?: string | null, contactID?: string | null, currency?: string | null, location?: string | null, ownerID?: string | null, ownerContact?: string | null, textHeader?: string | null, textFooter?: string | null }, details: Array<{ __typename?: 'SalesQuoteDetail', id: string, quoteID: string, lineNbr?: string | null, productID?: string | null, description?: string | null, quantity?: number | null, unitPrice?: number | null, extPrice?: number | null, discountPercent?: number | null, discountAmount?: number | null, akkreditiert?: boolean | null, LIMSguid?: string | null, norm?: string | null }> } | null };

export type GetSalesQuotesByOpportunityIDsQueryVariables = Exact<{
  opportunityIDs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetSalesQuotesByOpportunityIDsQuery = { __typename?: 'Query', getSalesQuotesByOpportunityIDs: Array<Array<{ __typename?: 'SalesQuote', id: string, quoteNbr?: string | null, businessAccount?: string | null, contactContact?: string | null, date?: string | null, description?: string | null, total?: number | null, status?: string | null, opportunityID?: string | null, expirationDate?: string | null, note?: string | null, contactID?: string | null, currency?: string | null, location?: string | null, ownerID?: string | null, ownerContact?: string | null, textHeader?: string | null, textFooter?: string | null, primary?: boolean | null }>> };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: Array<{ __typename?: 'User', id: string, displayName?: string | null, email?: string | null, userPrincipalName?: string | null }> };

export type GetCurrentWitnessesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentWitnessesQuery = { __typename?: 'Query', getCurrentWitnesses: Array<{ __typename?: 'Contact', id: string, contactID?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, email?: string | null, companyName?: string | null, title?: string | null, jobTitle?: string | null, gender?: string | null, phone1?: string | null, phone2?: string | null, phone3?: string | null, active?: boolean | null, businessAccount?: string | null, languageOrLocale?: string | null }> };

export type GetAllWitnessesQueryVariables = Exact<{
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllWitnessesQuery = { __typename?: 'Query', getAllWitnesses: Array<{ __typename?: 'Contact', id: string, contactID?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, email?: string | null, companyName?: string | null, title?: string | null, jobTitle?: string | null, gender?: string | null, phone1?: string | null, phone2?: string | null, phone3?: string | null, active?: boolean | null, businessAccount?: string | null, languageOrLocale?: string | null }> };

export type SearchWitnessesQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchWitnessesQuery = { __typename?: 'Query', searchWitnesses: Array<{ __typename?: 'Contact', id: string, contactID?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, email?: string | null, companyName?: string | null, title?: string | null, jobTitle?: string | null, gender?: string | null, phone1?: string | null, phone2?: string | null, phone3?: string | null, active?: boolean | null, businessAccount?: string | null, languageOrLocale?: string | null }> };
